import { Card, Steps, Tooltip, Collapse, Modal, Badge, Table } from "antd";
import React, { useState, useRef, useCallback } from "react";
import { useEffect } from "react";
import url from "../../services/url";
import CandidateDashboard from "../../layouts/CandidateDashboard";
import swal from "sweetalert";
import BASE from "../../config";
import { useHistory, useParams } from "react-router-dom";
import LoadingArea from "../../components/LoadingArea";
import "../Documents/forms/Html/formsStyle.css";
import { formatDateDDMMYYYY } from "../../utils/commonFunctions";
import { message } from "antd";
import RejectImage from "../../images/reject.jpg";
import { concentData } from "../../utils/concentData";
import { declarationData } from "../../utils/declarationData";
import useGetFile from "../../hooks/useGetFile";
import {
  ReadyForReview,
  Pending,
  Verified,
  Rejected,
  Accepted,
} from "../../components/components/StatusIndicators";
import ESIForm from "../Documents/forms/Html/LeagleDocuments/forms/ESIForm";
import Form11 from "../Documents/forms/Html/LeagleDocuments/forms/Form11";
import Wages from "../Documents/forms/Html/LeagleDocuments/forms/Wages";
import Gratuity from "../Documents/forms/Html/LeagleDocuments/forms/Gratuity";
import Accidental from "../Documents/forms/Html/LeagleDocuments/forms/Accidental";
import EPF from "../Documents/forms/Html/LeagleDocuments/forms/EPF";
import Mediclaim from "../Documents/forms/Html/LeagleDocuments/forms/Mediclaim";
import useLegalPrifilledData from "../../hooks/useLegalPrifilledData";
import useAuthCandidateToken from "../../hooks/useAuthCandidateToken";
import { LOGOS } from "../../utils/companyLogosObj";
import useAxios from "../../hooks/useAxios";
import { UserOutlined, InfoCircleOutlined } from "@ant-design/icons";
import LoadingApp from "./components/LoadingApp";
import useJoiningPrifilledData from "../../hooks/useJoiningPrifilledData";
import useConcentPrifilledData from "../../hooks/useConcentPrifilledData";
import useDeclarationPrefilledData from "../../hooks/useDeclarationPrefilledData";
import LegalDocument from "./components/LegalDocument";
import Guidelines from "./components/Guidelines";
import AadharCard from "./ui/AadharCard";
import Photo from "./ui/Photo";
import Signature from "./ui/Signature";
import PanCard from "./ui/PanCard";
import DocumentForms from "./ui/DocumentForms";
import OfferLetter from "./ui/OfferLetter";
import OfferLetterPopup from "./components/OfferLetterPopup";
import Indicator from "./components/Indicator";
import { getCandidateDetails } from "../../services/candidate/candidate.service";
import {
  getAllCompanyDocuments,
  getCandidateDeclarationDocument,
  getCandidateFilledCompanyDocuments,
} from "../../services/companyDocuments/companyDocuments.service";
import {
  getCandidateAgentInterviews,
  getCandidateNonAgentInterviews,
} from "../../services/interviews/interviews.service";

const { Step } = Steps;
const BUSINESSTYPE = ["kochar", "maxicus"];

const domParser = new DOMParser();

const normalizeFormName = (value = "") =>
  String(value || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

const getCompanyDocument = (form = {}) => form?.companyDocumentId || form;

const getCompanyDocumentName = (form = {}) => {
  const document = getCompanyDocument(form);

  return document?.companyDocumentNamesId?.documentName || document?.formName || "";
};

const isDeclarationDocument = (form = {}) => {
  const document = getCompanyDocument(form);
  const type = document?.formType || form?.formType || "";
  const status = document?.status ?? form?.status ?? true;

  return normalizeFormName(type) === "consent" && status === true;
};

const getObjectId = (value) => {
  if (!value) return "";
  if (typeof value === "object") return String(value?._id || value?.id || "");

  return String(value);
};

const pickDeclarationDocument = (documents = [], candidateDetails = {}) => {
  const businessType = normalizeFormName(candidateDetails?.trf?.businessType);
  const processId = getObjectId(candidateDetails?.trf?.processId);

  const declarationDocuments = documents.filter((document) => {
    const documentBusinessType = normalizeFormName(document?.businessType);
    const isGlobalBusinessType =
      !documentBusinessType || documentBusinessType === "all";

    if (!isDeclarationDocument(document)) return false;
    if (document?.isDocActive === false) return false;
    if (
      businessType &&
      !isGlobalBusinessType &&
      documentBusinessType !== businessType
    ) {
      return false;
    }

    return true;
  });

  if (declarationDocuments.length === 0) return null;

  return declarationDocuments
    .map((document, index) => {
      const documentBusinessType = normalizeFormName(document?.businessType);
      const documentProcessId = getObjectId(document?.processId);
      const createdAt = new Date(document?.createdAt || 0).getTime() || 0;
      let score = 0;

      if (processId && documentProcessId === processId) score += 100;
      if (businessType && documentBusinessType === businessType) score += 50;
      if (!documentProcessId) score += 10;

      return { document, index, score, createdAt };
    })
    .sort(
      (a, b) =>
        b.score - a.score || b.createdAt - a.createdAt || a.index - b.index,
    )[0].document;
};

const ViewApplication = () => {
  const api = useAxios();
  const { id } = useParams();
  const { filledData } = useLegalPrifilledData();
  const { filledJoiningData } = useJoiningPrifilledData();
  const { filledConcentData } = useConcentPrifilledData();
  const { filledDeclarationData } = useDeclarationPrefilledData();
  const { candidateToken } = useAuthCandidateToken();
  const { getImage } = useGetFile(candidateToken);
  const history = useHistory();
  const confirmedRef = useRef(false);
  const [application, setApplication] = useState();
  const [loading, setLoading] = useState(true);
  const [load, setLoad] = useState(false);
  const [stepsVisible, setStepsVisible] = useState({});
  const [step, setSteps] = useState(0);
  const [pageRefresh, setPageRefresh] = useState(false);
  const [businessType, setBusinessType] = useState("");
  const [metaData, setMetaData] = useState();
  const [ESIFormData, setESIFormData] = useState(null);
  const [ESIPreviewData, setESIPreviewData] = useState({});
  const [Form11FormData, setForm11FormData] = useState(null);
  const [Form11PreviewData, setForm11PreviewData] = useState({});
  const [WagesFormData, setWagesFormData] = useState(null);
  const [WagesPreviewData, setWagesPreviewData] = useState({});
  const [GratuityFormData, setGratuityFormData] = useState(null);
  const [GratuityPreviewData, setGratuityPreviewData] = useState({});
  const [AccidentalFormData, setAccidentalFormData] = useState(null);
  const [AccidentalPreviewData, setAccidentalPreviewData] = useState({});
  const [EPFFormData, setEPFFormData] = useState(null);
  const [EPFPreviewData, setEPFPreviewData] = useState({});
  const [MediclaimFormData, setMediclaimFormData] = useState(null);
  const [MediclaimPreviewData, setMediclaimPreviewData] = useState({});
  const [documentType, setDocumentType] = useState("Local");
  const [forms, setForms] = useState([]);
  const [leagleForms, setLeagleForms] = useState([]);
  const [filledForms, setFilledForms] = useState([]);
  const [checkListForms, setCheckListForms] = useState([]);
  const [checkListFormsOriginal, setCheckListFormsOriginal] = useState([]);
  const [activePanel, setActivePanel] = useState(null);
  const [showHideFooter, setShowHideFooter] = useState(false);
  const [accept, setAccept] = useState(false);
  const [companyDocId, setCompanyDocId] = useState("");
  const [aadharDetails, setAadharDetails] = useState();
  const [panDetails, setPanDetails] = useState();
  const [uanDetails, setUanDetails] = useState();
  const [acceptedForm, setAcceptedForm] = useState("");
  const [openUnderstandModal, setOpenUnderstandModal] = useState(false);
  const [formHtml, setFormHtml] = useState("");
  const [formLoading, setFormLoading] = useState(false);
  const [consentFormModal, setConsentFormModal] = useState(false);
  const [concentUrl, setConcentUrl] = useState("");
  const [declarationFormModal, setDeclarationFormModal] = useState(false);
  const [declarationUrl, setDeclarationUrl] = useState("");
  const [declarationAccept, setDeclarationAccept] = useState(false);
  const [checklistError, setChecklistError] = useState(false);
  const [consentRows, setConsentRows] = useState([]);
  const [declarationRows, setDeclarationRows] = useState([]);
  const [declarationCompanyDocument, setDeclarationCompanyDocument] =
    useState(null);
  const [declarationFilledForms, setDeclarationFilledForms] = useState([]);
  const [joiningRows, setJoiningRows] = useState([]);
  const [formId, setFormID] = useState();
  const [status, setStatus] = useState();
  const [leaglFormOpen, setLeaglFormOpen] = useState(false);
  const [leagleHtml, setLeagleHtml] = useState("");
  const [dynamicInterviews, setDynamicInterviews] = useState([]);
  const [interviews, setInterviews] = useState([]);
  const [dynamicSteps, setDynamicSteps] = useState(0);
  const underStandRef = useRef(false);
  const [files, setFiles] = useState({});
  const [open, setOpen] = useState(false);
  const [reject, setReject] = useState(false);
  const [isFieldTouch, setIsFieldTouch] = useState(false);
  const [toggleAlert, setToggleAlert] = useState(false);
  const [activeDocKey, setActiveDocKey] = useState(null);
  const [formFlip, setFormFlip] = useState(false);
  const [aiSettings, setAiSettings] = useState(null);
  const [offerLetterSended, setOfferLetterSended] = useState(null);
  const [offerLetterPopup, setOfferLetterPopup] = useState(false);
  const [declarationFormPopup, setDeclarationFormPopup] = useState(false);
  const [disabledDueToAadhar, setDisabledDueToAadhar] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const IS_NON_AGENT =
    application?.trf?.candidateType === "Non-Agent" ? true : false;
  const declarationFilledForm = (() => {
    const declarationDocumentId = declarationCompanyDocument?._id;

    return (
      declarationFilledForms.find((fill) => {
        const filledDocId = fill?.companyDocumentId?._id || fill?.companyDocumentId;

        return (
          declarationDocumentId &&
          filledDocId &&
          String(filledDocId) === String(declarationDocumentId)
        );
      }) ||
      declarationFilledForms.find((fill) =>
        isDeclarationDocument(fill?.companyDocumentId),
      ) ||
      null
    );
  })();
  const declarationDocument =
    declarationCompanyDocument || declarationFilledForm?.companyDocumentId;
  const isConsentAccepted = application?.concentStatus === true;
  const hasExistingConsentForm = (application?.concentForm?.length || 0) !== 0;
  const hasDeclarationPdf = Boolean(
    declarationFilledForm?.isPdfExist && declarationFilledForm?.filePath,
  );
  const isDeclarationSubmitted = declarationFilledForm?.isFilledStatus === true;
  const canSubmitDeclaration =
    !declarationFilledForm || declarationFilledForm?.isFilledStatus === false;
  const hasExistingDeclarationForm = Boolean(declarationFilledForm);
  const hasApprovedSignature = application?.candidateSignatureStatus === true;
  const canShowConsentForm = Boolean(
    application &&
      (hasApprovedSignature || hasExistingConsentForm || application?.IsSelected),
  );
  const canShowDeclarationForm = Boolean(
    application &&
      application?.isEmpTempIdCreated &&
      offerLetterSended &&
      (hasApprovedSignature || hasExistingDeclarationForm),
  );
  const shouldBlockDocumentationForDeclaration = Boolean(
    canShowDeclarationForm && !isDeclarationSubmitted,
  );
  const canShowLegalDocs = Boolean(
    application?.candidatePhotoStatus &&
      hasApprovedSignature &&
      isConsentAccepted &&
      (isDeclarationSubmitted || application?.isEmpTempIdCreated) &&
      application?.empId !== "" &&
      application?.empId !== null &&
      application?.trf?.position !== "" &&
      application?.DateOfJoining &&
      application?.isEmpTempIdCreated,
  );

  const loadApplication = async (
    fileFetch = true,
    doOperations = true,
    fileType = "",
  ) => {
    try {
      const { data } = await getCandidateDetails(api, { id }, "candidate");
      setApplication(data);
      if (doOperations) {
        setStepsVisible(data);
        setDocumentType(data.documentType ? data.documentType : "Local");
        setBusinessType(data?.trf?.businessType?.toLowerCase());
      }

      if (data.documentType === "S3" && BASE.storageType) {
        if (fileFetch) {
          const [photo, sign, aadhar, pan] = await Promise.all([
            getImage(data?.candidatePhoto?.[0]?.path),
            getImage(data?.candidateSignature?.[0]?.path),
            getImage(data?.aadharCardImage?.[0]?.path),
            getImage(data?.panCardImage?.[0]?.path),
          ]);

          setFiles({ photo, sign, aadhar, pan });
        } else {
          if (fileType === "photo") {
            const photo = await getImage(data?.candidatePhoto?.[0]?.path);
            setFiles({
              ...files,
              photo,
            });
          }
          if (fileType === "signature") {
            const sign = await getImage(data?.candidateSignature?.[0]?.path);
            setFiles({
              ...files,
              sign,
            });
          }
          if (fileType === "aadhar") {
            const aadhar = await getImage(data?.aadharCardImage?.[0]?.path);
            setFiles({
              ...files,
              aadhar,
            });
          }
          if (fileType === "pan") {
            const pan = await getImage(data?.panCardImage?.[0]?.path);
            setFiles({
              ...files,
              pan,
            });
          }
        }
      }

      return data;
    } catch (err) {
      console.log(err);
    } finally {
    }
  };

  useEffect(() => {
    if (!toggleAlert && !isFieldTouch) return;
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [toggleAlert, isFieldTouch]);

  useEffect(() => {
    if (!toggleAlert && !isFieldTouch) return;
    const unblock = history.block((tx) => {
      if (confirmedRef.current) {
        return true;
      }
      swal({
        title: "Are you sure?",
        text: "Are you sure you want to leave this form?",
        icon: "warning",
        dangerMode: true,
        buttons: true,
      }).then((willLeave) => {
        if (willLeave) {
          confirmedRef.current = true;
          unblock();
          history.push(tx.pathname);
        }
      });
      return false;
    });
    return () => {
      unblock();
    };
  }, [history, toggleAlert, isFieldTouch]);

  const handleAlert = (key) => {
    if (toggleAlert || isFieldTouch) {
      swal({
        title: "Are you sure?",
        text: "Are you sure that you want to leave this Form?",
        icon: "warning",
        dangerMode: true,
        buttons: true,
      }).then((willDelete) => {
        if (willDelete) {
          setActiveDocKey(key);
          setActivePanel(key);
          setIsFieldTouch(false);
          setToggleAlert(false);
        }
      });
    } else {
      setActiveDocKey(key);
      setActivePanel(key);
    }
  };

  const onBlurHandler = () => {
    setToggleAlert(true);
  };

  const isInputFieldTouched = () => {
    setIsFieldTouch(true);
  };

  const getAllJoiningForms = async () => {
    try {
      const forms = await getAllCompanyDocuments(api, "candidate");
      const documents = forms.data || [];
      const checklist_forms = documents.filter(
        (form) => form.formType === "Checklist",
      );
      const leagle_forms = documents.filter(
        (form) => form.formType === "Legal" && !isDeclarationDocument(form),
      );
      setCheckListForms([...checklist_forms]);
      setCheckListFormsOriginal([...checklist_forms]);
      setLeagleForms([...leagle_forms]);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (!businessType || !application) return;
    const checklist_forms = [...checkListFormsOriginal];

    let newForms = [];

    if (BUSINESSTYPE.includes(businessType?.toLowerCase())) {
      const formName =
        application.candidateType?.toLowerCase() === "support"
          ? "POLICY CHECKLIST SUPPORT"
          : "POLICY CHECKLIST AGENT";
      newForms = checklist_forms.filter(
        (form) =>
          form?.formName === formName &&
          form?.businessType?.toLowerCase() === businessType?.toLowerCase(),
      );
    } else {
      newForms = checklist_forms?.filter((form) => {
        if (form?.businessType?.toLowerCase() === businessType) {
          return form;
        }
      });
    }

    setCheckListForms([...newForms]);
  }, [businessType, application, checkListFormsOriginal]);

  const getAllJoiningFormsFiltered = async () => {
    try {
      const forms = await api.get(
        `/companyDocuments/candidateDocuments/${id}`,
        {
          tokenType: "candidate",
        },
      );
      const documents = forms.data || [];

      const joining_forms = documents.filter(
        (form) => form.formType === "Joining" && !isDeclarationDocument(form),
      );
      setForms([...joining_forms]);
    } catch (err) {
      console.log(err);
    }
  };

  const getAllJoiningFilledForms = async () => {
    try {
      const forms = await getCandidateFilledCompanyDocuments(
        api,
        { id },
        "candidate",
      );
      const mappings = forms.data || [];

      setDeclarationFilledForms([
        ...mappings.filter((form) => isDeclarationDocument(form)),
      ]);
      setFilledForms([
        ...mappings.filter((form) => !isDeclarationDocument(form)),
      ]);
    } catch (err) {
      console.log(err);
    }
  };

  const getDeclarationCompanyDocument = async (candidateDetails = application) => {
    try {
      const forms = await getCandidateDeclarationDocument(api, "candidate");
      const document = pickDeclarationDocument(forms.data || [], candidateDetails);

      setDeclarationCompanyDocument(document || null);
      return document || null;
    } catch (err) {
      console.log(err);
      setDeclarationCompanyDocument(null);
      return null;
    }
  };

  const getDynamicInterviews = async (candidate) => {
    const { trf } = candidate;
    try {
      const dynamicInterviews = await getCandidateNonAgentInterviews(
        api,
        {
          id: candidate?._id,
          departmentId: trf?.departmentId,
          designationId: trf?.designationId,
        },
        "candidate",
      );

      const dynamic = dynamicInterviews.data?.sort(
        (a, b) => a?.interviewNo - b?.interviewNo,
      );
      let done = [];
      let pending = [];

      dynamic.forEach((item) => {
        const Founded = interviews?.find(
          (ele) => item?._id === ele?.designationInterviewsNamesMappingId,
        );
        if (Founded) {
          if (Founded.finished) {
            done.push({
              ...item,
              interviewDetailsBind: Founded,
            });
          } else {
            pending.push({
              ...item,
              interviewDetailsBind: Founded,
            });
          }
        } else {
          pending.push({
            ...item,
            interviewDetailsBind: {},
          });
        }
      });
      done.sort((a, b) => b.interviewNo - a.interviewNo);
      pending.sort((a, b) => a.interviewNo - b.interviewNo);
      const final = [...pending, ...done];
      setDynamicInterviews(final);
    } catch (err) {
      console.log(err);
    }
  };

  const getInterviews = async (_id) => {
    try {
      const interviews = await getCandidateAgentInterviews(
        api,
        { id: _id },
        "candidate",
      );
      setInterviews(interviews.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchAiStatus = async () => {
    try {
      const { data } = await api.get(`/AIServiceSettings`, {
        tokenType: "candidate",
      });
      setAiSettings(data?.AIServiceSettings);
      const isActive = !data?.AIServiceSettings?.isActive;

      setShowNotification(isActive);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchOfferLetter = async (_id) => {
    try {
      const { data } = await api.get(`/offerLetter/${_id}`, {
        tokenType: "candidate",
      });
      setOfferLetterSended(data?.OffetLetter);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const init = async () => {
      try {
        setLoading(true);
        const [app] = await Promise.all([
          loadApplication(),
          getMetaData(),
          getAadharAndPanDetails(),
          fetchAiStatus(),
          getInterviews(id),
          fetchOfferLetter(id),
          getAllJoiningFilledForms(),
        ]);
        if (app) {
          const promises = [];
          if (app?.trf?.candidateType === "Non-Agent") {
            promises.push(getDynamicInterviews(app));
          }
          await Promise.all(promises);
        }
        await Promise.all([
          getDeclarationCompanyDocument(app),
          getAllJoiningForms(),
          getAllJoiningFormsFiltered(),
        ]);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    init();
  }, []);

  useEffect(() => {
    if (
      application?.candidatePhoto?.length === 0 &&
      application?.candidateSignature?.length === 0 &&
      underStandRef.current === false
    ) {
      if (!underStandRef.current) {
        setOpenUnderstandModal(true);
      }
      underStandRef.current = true;
    }
  }, [application]);

  const hideColumnReason = (e) => {
    return filledForms?.every(
      (fill) =>
        fill.formStatusByHR === true ||
        fill.formStatusByHR === null ||
        fill.isFilledStatus === true,
    );
  };

  const consentColumns = [
    {
      title: "Form Name",
      dataIndex: "form_name",
      key: "form_name",
      width: "30%",
    },
    {
      title: "Rejected Reason",
      dataIndex: "reject_reason",
      key: "reject_reason",
      width: "25%",
    },
    {
      title: "Accepted On",
      dataIndex: "accepted_on",
      key: "accepted_on",
      width: "15%",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "15%",
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      fixed: "right",
      width: "15%",
      render: (val, record) => {
        return (
          <>
            <button
              style={{ flex: 1 }}
              className="btn-sm btn-primary w-100"
              onClick={async (e) => {
                e.preventDefault();

                if (application?.candidateSignatureStatus === false) {
                  message.error(
                    "The signature has not yet been approved by HR.",
                  );
                  return;
                }
                generateConcentPdf();
                setConsentFormModal(true);
              }}
            >
              View Consent Form
            </button>
          </>
        );
      },
    },
  ];

  const declarationColumns = [
    {
      title: "Form Name",
      dataIndex: "form_name",
      key: "form_name",
      width: "30%",
    },
    {
      title: "Rejected Reason",
      dataIndex: "reject_reason",
      key: "reject_reason",
      width: "25%",
    },
    {
      title: "Accepted On",
      dataIndex: "accepted_on",
      key: "accepted_on",
      width: "15%",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "15%",
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      fixed: "right",
      width: "15%",
      render: () => {
        const isDeclarationActionDisabled =
          !application?.offerLetterAccepted;

        return (
          <>
            <button
              style={{ flex: 1 }}
              className={`btn-sm btn-${
                isDeclarationActionDisabled ? "secondary" : "primary"
              } w-100`}
              disabled={isDeclarationActionDisabled}
              title={
                isDeclarationActionDisabled
                  ? "Please accept your offer letter first."
                  : ""
              }
              onClick={async (e) => {
                e.preventDefault();

                if (!hasExistingDeclarationForm && !hasApprovedSignature) {
                  message.error(
                    "Please upload and get your signature approved before continuing.",
                  );
                  return;
                }

                setDeclarationUrl("");
                setDeclarationAccept(false);
                setDeclarationFormModal(true);

                const isPreviewReady = await generateDeclarationPdf();
                if (!isPreviewReady) {
                  setDeclarationFormModal(false);
                }
              }}
            >
              View Declaration Form
            </button>
          </>
        );
      },
    },
  ];

  const joiningColumns = [
    {
      title: "Form Name",
      dataIndex: "form_name",
      key: "form_name",
    },
    {
      title: "Accepted On",
      dataIndex: "accepted_on",
      key: "accepted_on",
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      fixed: "right",
      render: (val, record) => {
        const IS_DISABLE =
          record?.action?.status === false
            ? !application?.candidateSignatureStatus
              ? true
              : false
            : false;
        const IS_DISABLE_PHOTO =
          record?.action?.status === false
            ? !application?.candidatePhotoStatus
              ? true
              : false
            : false;
        return (
          <>
            <button
              style={{ flex: 1 }}
              className={`btn-sm btn-${
                IS_DISABLE ||
                (record?.action?.form.formName ===
                "IT Department Resource Usage Policy"
                  ? IS_DISABLE_PHOTO
                  : false)
                  ? "secondary"
                  : "primary"
              } w-100`}
              disabled={
                IS_DISABLE ||
                (record?.action?.form.formName ===
                "IT Department Resource Usage Policy"
                  ? IS_DISABLE_PHOTO
                  : false)
              }
              onClick={(e) => {
                e.preventDefault();
                if (!application?.offerLetterAccepted) {
                  setOfferLetterPopup(true);
                  return;
                }
                if (shouldBlockDocumentationForDeclaration) {
                  setDeclarationFormPopup(true);
                  return;
                }
                record?.action?.filled
                  ? record?.action?.status === null
                    ? getFilledFormPreviewData(
                        e,
                        record?.action?.formId,
                        record?.action?.filled,
                        record?.action?.status,
                        record?.action?.accepted,
                        record?.action?.formData,
                        record?.action?.documentDetails,
                        record?.action?.form,
                      )
                    : getFilledFormPreviewData(
                        e,
                        record?.action?.formId,
                        record?.action?.filled,
                        record?.action?.status,
                        record?.action?.accepted,
                        record?.action?.formData,
                        record?.action?.documentDetails,
                        record?.action?.form,
                      )
                  : getFormPreviewData(
                      e,
                      record?.action?.formId,
                      record?.action?.filled,
                      record?.action?.status,
                      record?.action?.accepted,
                      record?.action?.formData,
                      record?.action?.documentDetails,
                      record?.action?.form,
                    );
              }}
            >
              {record?.action?.form.formName === "Willingness Document"
                ? record?.action?.filled
                  ? status === null
                    ? "View Form"
                    : status
                      ? "View Form"
                      : "Re Fill Form"
                  : "Fill Form"
                : record?.action?.filled
                  ? record?.action?.status === null
                    ? "View Form"
                    : record?.action?.status
                      ? "View Form"
                      : "Accept Form"
                  : "Accept Form"}
            </button>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    setConsentRows([
      {
        form_name: "Employee Onboarding Consent",
        accepted_on: application?.concentDate
          ? formatDateDDMMYYYY(new Date(application?.concentDate))
          : "",
        status: application?.concentStatus ? <Accepted /> : <Pending />,
        action: application,
        reject_reason:
          application?.candidateSignatureStatus === false ? (
            <div className="d-flex reject" style={{ color: "red" }}>
              {application?.candidateSignatureRejection}
            </div>
          ) : (
            ""
          ),
      },
    ]);
  }, [application]);

  useEffect(() => {
    const hrStatus = declarationFilledForm?.formStatusByHR;
    const filledStatus = declarationFilledForm?.isFilledStatus;
    let status = <Pending />;

    if (hrStatus === false) {
      status = <Rejected />;
    } else if (filledStatus === true || hrStatus === true) {
      status = <Accepted />;
    }

    setDeclarationRows([
      {
        form_name:
          getCompanyDocumentName(declarationDocument) ||
          "Declaration - Cum - Undertaking",
        accepted_on:
          (filledStatus === true || hrStatus === true) &&
          declarationFilledForm?.updatedAt
            ? formatDateDDMMYYYY(new Date(declarationFilledForm.updatedAt))
            : "",
        status,
        action: application,
        reject_reason:
          hrStatus === false && declarationFilledForm?.remarks ? (
            <div className="d-flex reject" style={{ color: "red" }}>
              {declarationFilledForm.remarks}
            </div>
          ) : (
            ""
          ),
      },
    ]);
  }, [application, declarationDocument, declarationFilledForm]);

  useEffect(() => {
    let rows = [];
    forms.map((form) => {
      const formName =
        form?.companyDocumentNamesId?.documentName || form?.formName;
      let filled = false;
      let status = null;
      let updatedAt;
      let remarks = "";
      let isFilled = false;
      let accepted = "";
      let documentDetails = "";
      filledForms?.map((fill) => {
        if (form._id === fill.companyDocumentId._id) {
          filled = true;
          status = fill.formStatusByHR;
          updatedAt = fill.updatedAt;
          remarks = fill.remarks;
          isFilled = fill.isFilledStatus;
          accepted = fill.createdAt;
          documentDetails = fill.documentDetails;
        }
      });
      if (businessType === form.businessType.toLowerCase()) {
        if (
          form.formName === "Willingness Document" &&
          application?.candidateType?.toLowerCase() === "support"
        )
          return;

        rows.push({
          form_name: formName,
          accepted_on: updatedAt ? formatDateDDMMYYYY(new Date(updatedAt)) : "",
          reason: isFilled === false && status === false && (
            <span style={{ color: "red" }}>{remarks}</span>
          ),
          status:
            isFilled === false && status === null ? (
              <Pending />
            ) : (
              <>
                {(status === null || status === false) && isFilled === true ? (
                  <ReadyForReview />
                ) : (
                  <>{status ? <Verified /> : <Rejected />}</>
                )}
              </>
            ),
          action: {
            formId: form._id,
            filled,
            status,
            accepted,
            formData: form.formData,
            documentDetails,
            form,
          },
        });
      }
    });
    setJoiningRows(rows);
  }, [forms, filledForms, application]);

  const acceptFormHandler = async (e) => {
    setChecklistError("");
    e.preventDefault();
    let fieldValues = {};
    let form = document.getElementById("willing_form");
    let checklist = document.getElementById("checklist_form");
    if (form !== null) {
      for (let i = 0; i < form.elements.length; i++) {
        let element = form.elements[i];
        if (element.nodeName === "INPUT" && element.hasAttribute("name")) {
          fieldValues[element.getAttribute("name")] = element.value;
        }
      }
      for (let key in fieldValues) {
        if (key.startsWith("remark") && !fieldValues[key]) {
          message.error("All remarks are required.");
          return;
        }
      }
    }

    if (checklist !== null) {
      for (let i = 0; i < checklist.elements.length; i++) {
        let element = checklist.elements[i];
        if (element.nodeName === "INPUT" && element.hasAttribute("name")) {
          fieldValues[element.getAttribute("name")] = element.checked;
        }
      }
      for (let key in fieldValues) {
        if (!fieldValues[key]) {
          message.error(
            "Please ensure all checkboxes are selected before submitting the form.",
          );
          return;
        }
      }
    }

    setChecklistError(false);

    setFormLoading(true);
    try {
      await api.post(
        `/companyDocuments/DocumentMaping`,
        {
          companyDocumentId: companyDocId,
          candidateId: id,
          documentDetails:
            Object.keys(fieldValues).length !== 0 ? fieldValues : null,
          formStatus: true,
        },
        { tokenType: "candidate" },
      );
      setOpen(false);
      setAccept(false);
      await getAllJoiningFilledForms();
    } catch (err) {
      console.error(err);
    } finally {
      setFormLoading(false);
    }
  };

  const getAadharAndPanDetails = async () => {
    try {
      const result = await api.get(
        `/candidateDocuments/documentVerificationDetails/candidate/${id}`,
        { tokenType: "candidate" },
      );

      let foundAadhar = false;
      let foundPan = false;
      let foundUan = false;

      if (Array.isArray(result?.data)) {
        result.data.forEach((details) => {
          if (details.documentType === "Aadhar_Card") {
            setAadharDetails(details);
            foundAadhar = true;
          } else if (details.documentType === "Pan_Card") {
            setPanDetails(details);
            foundPan = true;
          } else if (details.documentType === "UAN_History") {
            if (details.documentStatus) {
              setUanDetails(details);
            } else {
              setUanDetails({});
            }
            foundUan = true;
          }
        });
      }

      if (!foundAadhar) setAadharDetails(undefined);
      if (!foundPan) setPanDetails(undefined);
      if (!foundUan) setUanDetails(undefined);
    } catch (err) {
      console.log(err);
    }
  };

  const getMetaData = async () => {
    try {
      const result = await api.get(
        `/candidateDocuments/candidateAllDetails/getCandidateDetails/${id}`,
        { tokenType: "candidate" },
      );
      setMetaData(result.data);
      return true;
    } catch (err) {
      console.log(err);
      return false;
    }
  };

  useEffect(() => {
    const preview = document.getElementById("joining_preview");
    if (preview && formHtml) {
      preview.appendChild(formHtml);
    }

    return () => {
      if (preview && formHtml) {
        preview.removeChild(formHtml);
      }
    };
  }, [open, formHtml, formFlip]);

  const getFilledFormPreviewData = async (
    e,
    _id,
    filled,
    status,
    accepted,
    formData,
    documentDetails,
    form,
  ) => {
    setAcceptedForm(accepted);
    await getFormPreviewData(
      e,
      _id,
      filled,
      status,
      accepted,
      formData,
      documentDetails,
      form,
    );
    setFormID(_id);
    setStatus(status);
  };

  const getFormPreviewData = async (
    e,
    id,
    filled,
    status,
    accepted,
    formData,
    documentDetails,
    form,
  ) => {
    const _html = domParser.parseFromString(formData, "text/html");
    if (_html.getElementById("logo") !== null) {
      _html.getElementById("logo").src = LOGOS[businessType];
    }
    const previewHtml = filledJoiningData(
      _html,
      status,
      application,
      files?.photo,
      files?.sign,
      documentType,
      aadharDetails,
      documentDetails,
      form,
      metaData,
      acceptedForm,
    );

    setFormHtml(previewHtml.getElementById("container"));

    setAcceptedForm(accepted);

    setOpen(true);
    if (filled) {
      if (status === null) {
        setShowHideFooter(false);
      } else {
        // setShowHideFooter(true)
        if (status) {
          setShowHideFooter(false);
        } else {
          setShowHideFooter(true);
        }
      }
    } else {
      setShowHideFooter(true);
    }
    setTimeout(() => {
      setFormFlip((prev) => !prev);
    }, 200);
    setCompanyDocId(id);
  };

  const acceptConsentFormHandler = async (e) => {
    e.preventDefault();
    setFormLoading(true);
    try {
      await api.put(
        `/candidate/concentStatus/${id}`,
        { concentStatus: true },
        { tokenType: "candidate" },
      );
      loadApplication(false, false);
      setConsentFormModal(false);
      setFormLoading(false);
      setAccept(false);
    } catch (err) {
      setFormLoading(false);
      console.log(err);
    }
  };

  const acceptDeclarationFormHandler = async (e) => {
    e.preventDefault();
    setFormLoading(true);
    try {
      const document = await ensureDeclarationCompanyDocument();

      if (!document?._id) {
        message.error("Declaration Form configuration was not found.");
        return;
      }

      const signature = await ensureDeclarationSignature();
      if (!signature) {
        message.error(
          "Signature file is not available yet. Please try again after the signature is loaded.",
        );
        return;
      }

      const html = getDeclarationHtml(signature, document);
      const mappingResponse = await api.post(
        `/companyDocuments/DocumentMaping`,
        {
          companyDocumentId: document._id,
          candidateId: id,
          documentDetails: {
            consent: true,
            consentDate: new Date().toISOString(),
          },
          formStatus: true,
        },
        { tokenType: "candidate" },
      );
      const mappingId = mappingResponse?.data?._id || declarationFilledForm?._id;

      if (!mappingId) {
        throw new Error("Declaration Form mapping could not be created.");
      }

      const result = await api.post(
        `/companyDocuments/htmltoPdf`,
        getDeclarationPdfPayload(mappingId, html, document),
        { tokenType: "candidate" },
      );

      setDeclarationUrl(result.data);
      await getAllJoiningFilledForms();
      await loadApplication(false, false);
      setDeclarationFormModal(false);
      setDeclarationAccept(false);
      message.success("Declaration Form submitted successfully.");
    } catch (err) {
      message.error(
        err?.response?.data?.message ||
          "Declaration Form could not be submitted.",
      );
      console.log(err);
    } finally {
      setFormLoading(false);
    }
  };

  useEffect(() => {
    const preview = document.getElementById("legal_preview");
    if (preview && leagleHtml) {
      preview.appendChild(leagleHtml);
    }

    return () => {
      if (preview && leagleHtml) {
        preview.removeChild(leagleHtml);
      }
    };
  }, [leagleHtml, leaglFormOpen, formFlip]);

  useEffect(() => {
    leagleForms.map((form) => {
      return filledForms?.map((_form) => {
        if (
          form?._id === _form?.companyDocumentId?._id &&
          _form?.companyDocumentId?.formName === "ESI Form"
        ) {
          setESIFormData(_form);
          setESIPreviewData(_form?.documentDetails);
        } else if (
          form?._id === _form?.companyDocumentId?._id &&
          _form?.companyDocumentId?.formName === "Form 11"
        ) {
          setForm11FormData(_form);
          setForm11PreviewData(_form?.documentDetails);
        } else if (
          form?._id === _form?.companyDocumentId?._id &&
          _form?.companyDocumentId?.formName === "Wages Form"
        ) {
          setWagesFormData(_form);
          setWagesPreviewData(_form?.documentDetails);
        } else if (
          form?._id === _form?.companyDocumentId?._id &&
          _form?.companyDocumentId?.formName === "Gratuity Form"
        ) {
          setGratuityFormData(_form);
          setGratuityPreviewData(_form?.documentDetails);
        } else if (
          form?._id === _form?.companyDocumentId?._id &&
          _form?.companyDocumentId?.formName === "Accidental Form"
        ) {
          setAccidentalFormData(_form);
          setAccidentalPreviewData(_form?.documentDetails);
        } else if (
          form?._id === _form?.companyDocumentId?._id &&
          _form?.companyDocumentId?.formName === "EPF Form"
        ) {
          setEPFFormData(_form);
          setEPFPreviewData(_form?.documentDetails);
        } else if (
          form?._id === _form?.companyDocumentId?._id &&
          _form?.companyDocumentId?.formName === "Mediclaim Form"
        ) {
          setMediclaimFormData(_form);
          setMediclaimPreviewData(_form?.documentDetails);
        }
      });
    });
  }, [leagleForms, filledForms]);

  const getLeagleFormPreviewData = async (_form, _photo, _sign) => {
    if (_form) {
      const _html = domParser.parseFromString(_form?.formData, "text/html");
      let values;
      if (_form.formName === "Mediclaim Form") {
        values = MediclaimPreviewData;
      }

      if (_form.formName === "Accidental Form") {
        values = AccidentalPreviewData;
      }

      if (_form.formName === "ESI Form") {
        values = ESIPreviewData;
      }

      if (_form.formName === "EPF Form") {
        values = EPFPreviewData;
      }

      if (_form.formName === "Gratuity Form") {
        values = GratuityPreviewData;
      }

      if (_form.formName === "Form 11") {
        values = Form11PreviewData;
      }

      if (_form.formName === "Wages Form") {
        values = WagesPreviewData;
      }

      const previewHtml = filledData(
        _html,
        values,
        application,
        _photo,
        _sign,
        documentType,
      );

      setLeagleHtml(previewHtml?.getElementById("container"));
      setLeaglFormOpen(true);

      setTimeout(() => {
        setFormFlip((prev) => !prev);
      }, 200);
    }
  };

  const generateConcentPdf = async () => {
    if (application?.isConcentFormPdfExist) {
      const pdfUrl = await getImage(application?.concentForm?.[0]?.path);
      setConcentUrl(pdfUrl);
      return;
    }

    const htmlElement = domParser.parseFromString(
      concentData[businessType]?.text,
      "text/html",
    );

    const previewHtml = filledConcentData(
      htmlElement,
      application,
      files?.sign,
      aadharDetails,
    );

    try {
      setLoad(true);
      const result = await api.post(
        `/companyDocuments/htmltoPdfConcentForm`,
        {
          candidateId: id,
          html: `<div id="container">
        ${previewHtml.getElementById("container").innerHTML}
      </div>`,
        },
        { tokenType: "candidate" },
      );
      setConcentUrl(result.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoad(false);
    }
  };

  async function ensureDeclarationSignature() {
    if (files?.sign) {
      return files.sign;
    }

    const signaturePath = application?.candidateSignature?.[0]?.path;
    if (!signaturePath) {
      return "";
    }

    const signature = await getImage(signaturePath);
    if (signature) {
      setFiles((currentFiles) => ({
        ...currentFiles,
        sign: signature,
      }));
    }

    return signature || "";
  }

  async function ensureDeclarationCompanyDocument() {
    if (declarationDocument?._id) {
      return declarationDocument;
    }

    return getDeclarationCompanyDocument(application);
  }

  function getDeclarationHtml(signature = files?.sign, document = declarationDocument) {
    const template =
      document?.formData ||
      declarationData[businessType]?.text ||
      declarationData.maxicus.text;
    const htmlElement = domParser.parseFromString(template, "text/html");

    const previewHtml = filledDeclarationData(
      htmlElement,
      application,
      signature,
      aadharDetails,
      businessType,
    );
    const container = previewHtml?.getElementById("container");

    if (!container) {
      throw new Error("Declaration Form template could not be prepared.");
    }

    return container.outerHTML;
  }

  function getDeclarationPdfPayload(
    mappingId,
    html,
    document = declarationDocument,
  ) {
    return {
      wef: document?.WEF
        ? `W.E.F : ${formatDateDDMMYYYY(new Date(document.WEF))}`
        : "",
      formName: "Candidate Onboarding Declaration Form",
      companyDocumentId: mappingId,
      candidateId: id,
      docNumber: document?.docNo ? `DOC NO : ${document.docNo}` : "",
      companyName:
        businessType ||
        application?.trf?.businessType?.toLowerCase() ||
        "maxicus",
      revisionNumber: document?.revNo
        ? `REV. NO : ${document.revNo}`
        : "",
      autoAcceptWithoutHr: true,
      formStatusByHR: true,
      html,
    };
  }

  function getDeclarationPdfPreviewPayload(html, document = declarationDocument) {
    return {
      wef: document?.WEF
        ? `W.E.F : ${formatDateDDMMYYYY(new Date(document.WEF))}`
        : "",
      formName: "Candidate Onboarding Declaration Form",
      docNumber: document?.docNo ? `DOC NO : ${document.docNo}` : "",
      companyName:
        businessType ||
        application?.trf?.businessType?.toLowerCase() ||
        "maxicus",
      revisionNumber: document?.revNo
        ? `REV. NO : ${document.revNo}`
        : "",
      html,
    };
  }

  const generateDeclarationPdf = async () => {
    try {
      setLoad(true);
      const document = await ensureDeclarationCompanyDocument();

      if (!document?._id) {
        message.error("Declaration Form configuration was not found.");
        return false;
      }

      if (hasDeclarationPdf) {
        const pdfUrl = await getImage(declarationFilledForm.filePath);
        setDeclarationUrl(pdfUrl);
        return true;
      }

      const signature = await ensureDeclarationSignature();
      if (!signature) {
        message.error(
          "Signature file is not available yet. Please try again after the signature is loaded.",
        );
        return false;
      }

      const html = getDeclarationHtml(signature, document);
      const result = await api.post(
        `/companyDocuments/htmltoPdfTemplate`,
        getDeclarationPdfPreviewPayload(html, document),
        { tokenType: "candidate" },
      );
      const uint8Array = new Uint8Array(result.data.data);
      const previewUrl = URL.createObjectURL(
        new Blob([uint8Array], { type: "application/pdf" }),
      );

      setDeclarationUrl(previewUrl);
      return true;
    } catch (err) {
      message.error(
        err?.response?.data?.message ||
          "Declaration Form preview could not be generated.",
      );
      console.log(err);
      return false;
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    let STEP = 0;
    if (dynamicInterviews.length !== 0) {
      Array.from([...dynamicInterviews])
        ?.sort((a, b) => a.interviewNo - b.interviewNo)
        ?.map((item) => {
          const Founded = interviews?.find(
            (ele) => item?._id === ele?.designationInterviewsNamesMappingId,
          );
          if (Founded && Founded?.finished) {
            STEP = item?.interviewNo;
          }
        });
    }

    if (application?.isDocumentSent === true) {
      STEP = dynamicInterviews?.length;
    }

    if (
      application?.isEmpTempIdCreated === true &&
      application?.documentsVerifiedStatus === true
    ) {
      STEP = STEP + 1;
    }

    setDynamicSteps(STEP);
  }, [interviews, dynamicInterviews, application]);

  const findInterviewByType = useCallback(
    (type) => {
      const Founded = interviews?.find((ele) => ele?.type == type);
      if (Founded) {
        if (Founded.finished) {
          return "finish";
        } else {
          return "wait";
        }
      } else {
        return "wait";
      }
    },
    [interviews],
  );

  const getFinalOrVersantStepTitle = () => {
    const thirdInterview = interviews?.[2];

    if (!thirdInterview || thirdInterview?.type === "clientRound") {
      return "Final/Versant Round";
    }

    if (
      thirdInterview?.type === "versant" &&
      thirdInterview?.isVersantNotRequired
    ) {
      return "Final Round";
    }

    return `${thirdInterview?.type?.[0]?.toUpperCase()}${thirdInterview?.type?.slice(
      1,
    )} Round`;
  };

  const isDocumentReadyForSend = () => {
    if (dynamicInterviews.length !== 0 && IS_NON_AGENT) {
      if (interviews?.length !== dynamicInterviews?.length) {
        for (let item of interviews) {
          if (item?.status === "Rejected") {
            return false;
          }
        }
        return null;
      }

      if (interviews?.length === dynamicInterviews?.length) {
        const isSelected = interviews?.every(
          (item) => item?.status === "Selected",
        );
        if (isSelected) {
          return true;
        }

        return null;
      }
    } else {
      const versantInterview = interviews?.find(
        (item) => item?.type === "versant",
      );
      const isClientRoundExist = versantInterview?.clientRoundExist;
      const isVersantNotRequired = versantInterview?.isVersantNotRequired;

      if (isClientRoundExist || isVersantNotRequired) {
        if (interviews.length === 4) {
          const isSelected = interviews?.every(
            (item) => item?.status === "Selected",
          );
          if (isSelected) {
            return true;
          }
        } else {
          return null;
        }
      } else {
        if (interviews.length === 3) {
          const isSelected = interviews?.every(
            (item) => item?.status === "Selected",
          );
          if (isSelected) {
            return true;
          }
        } else {
          return null;
        }
      }
      return null;
    }
  };

  const legalDocsCommonProps = {
    leagleForms,
    files,
    getLeagleFormPreviewData,
    application,
    aadharDetails,
    metaData,
    getAllJoiningFilledForms,
    setActivePanel,
    setIsFieldTouch,
  };

  return (
    <CandidateDashboard>
      {loading ? (
        <LoadingApp />
      ) : (
        <>
          <div className="candidate-details two">
            {showNotification && (
              <Indicator setShowNotification={setShowNotification} />
            )}
            <div className="container">
              <div className="row bg-white border py-3 align-items-center">
                <div className="col-md-2 d-flex justify-content-center align-items-center flex-column">
                  {/* <h5 className="m-0 text-center">{application?.trf?.title}</h5>
                  <p className="text-gray text-center mb-0">
                    {application?.trf?.department}, {application?.trf?.location}
                  </p> */}
                  {application?.candidatePhoto &&
                  application?.candidatePhoto?.length !== 0 ? (
                    <>
                      {application?.candidatePhoto && (
                        <img
                          style={{
                            width: 100,
                            height: 100,
                            border: "1px solid #fd7e14",
                          }}
                          className="img rounded-circle"
                          src={
                            documentType === "S3" && BASE.storageType
                              ? files?.photo
                              : url() + application?.candidatePhoto[0]?.path
                          }
                          alt="profile"
                        />
                      )}
                    </>
                  ) : (
                    <div
                      style={{
                        width: "100px",
                        height: "100px",
                        border: "1px solid black",
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <UserOutlined style={{ fontSize: "4rem" }} />
                    </div>
                  )}
                  <h4 className="mt-1 text-capitalize text-center">
                    {application?.name}
                  </h4>
                </div>
                {IS_NON_AGENT ? (
                  <div
                    className="col-lg-10 my-lg-0 my-2"
                    style={{ padding: "0 30px" }}
                  >
                    <Steps
                      current={dynamicSteps}
                      size="small"
                      labelPlacement="vertical"
                      percent={60}
                    >
                      {Array.from([...dynamicInterviews])
                        ?.sort((a, b) => a.interviewNo - b.interviewNo)
                        ?.map((item) => {
                          const Founded = interviews?.find(
                            (ele) =>
                              item?._id ===
                              ele?.designationInterviewsNamesMappingId,
                          );
                          return (
                            <Step
                              key={Math.random()}
                              className="custum_step"
                              status={
                                Founded && Founded?.finished === true
                                  ? "finish"
                                  : "wait"
                              }
                              title={item?.interviewDetails?.interviewNames}
                              subTitle={
                                Founded &&
                                Founded?.rejectionReason !== "" && (
                                  <img
                                    src={RejectImage}
                                    style={{ width: 50, height: 50 }}
                                    alt=""
                                  />
                                )
                              }
                            />
                          );
                        })}
                      <Step title={"Document Verification"} />
                      <Step
                        className={stepsVisible?.IsSelected ? "onboard" : ""}
                        title={
                          stepsVisible?.IsSelected ? (
                            <span
                              style={{
                                color: "green",
                              }}
                            >
                              Onboarded
                            </span>
                          ) : (
                            <span>Onboarding</span>
                          )
                        }
                      />
                    </Steps>
                  </div>
                ) : (
                  <div
                    className="col-lg-10 my-lg-0 my-2"
                    style={{ padding: "0 30px" }}
                  >
                    <Steps
                      current={step}
                      size="small"
                      labelPlacement="vertical"
                      percent={60}
                    >
                      <Step
                        title="L1 Round"
                        status={findInterviewByType("L1")}
                        subTitle={
                          stepsVisible.L1_Status === "Rejected" && (
                            <img
                              src={RejectImage}
                              style={{ width: 50, height: 50 }}
                              alt=""
                            />
                          )
                        }
                      />
                      <Step
                        title="L2 Round"
                        status={findInterviewByType("L2")}
                        subTitle={
                          stepsVisible.L2_Status === "Rejected" && (
                            <img
                              src={RejectImage}
                              style={{ width: 50, height: 50 }}
                              alt=""
                            />
                          )
                        }
                      />

                      <Step
                        title={getFinalOrVersantStepTitle()}
                        status={findInterviewByType(
                          interviews[2]
                            ? interviews[2]?.type === "clientRound"
                              ? "final/versant"
                              : interviews[2]?.type
                            : "Final/Versant Round",
                        )}
                        subTitle={
                          stepsVisible.L3_Status === "Rejected" && (
                            <img
                              src={RejectImage}
                              style={{ width: 50, height: 50 }}
                              alt=""
                            />
                          )
                        }
                      />

                      <Step
                        title="Client Round"
                        status={findInterviewByType("clientRound")}
                        subTitle={
                          stepsVisible.L4_Status === "Rejected" && (
                            <img
                              src={RejectImage}
                              style={{ width: 50, height: 50 }}
                              alt=""
                            />
                          )
                        }
                      />

                      <Step
                        title="Document Verification"
                        status={
                          isDocumentReadyForSend() ||
                          application?.isDocumentSent
                            ? application.documentsVerifiedStatus === false
                              ? "process"
                              : "finish"
                            : "wait"
                        }
                      />

                      <Step
                        className={stepsVisible?.IsSelected ? "onboard" : ""}
                        title={
                          stepsVisible?.IsSelected ? (
                            <span
                              style={{
                                color: "green",
                                fontWeight: "bold",
                              }}
                            >
                              Onboarded
                            </span>
                          ) : (
                            <span>Onboarding</span>
                          )
                        }
                      />
                    </Steps>
                  </div>
                )}
              </div>
              <div className="row mt-4">
                <div className="col-md-12 p-0">
                  {application?.isEmpTempIdCreated &&
                    application?.IsSelected &&
                    application?.documentsVerifiedStatus && (
                      <>
                        <Card
                          className={" bg-white mb-4"}
                          title="Company Policy Document"
                        >
                          {application?.IsSelected && (
                            <div className="table-responsive">
                              <table className="table">
                                <thead className="table-head">
                                  <tr>
                                    <td className="table-column-head">
                                      Form Name
                                    </td>
                                    {!hideColumnReason() && (
                                      <td className="table-column-head">
                                        Reason
                                      </td>
                                    )}
                                    <td className="table-column-head">
                                      Approved On (DD-MM-YYYY)
                                    </td>
                                    <td className="table-column-head">
                                      Status
                                    </td>
                                    <td className="table-column-head text-center">
                                      Action
                                    </td>
                                  </tr>
                                </thead>
                                <tbody>
                                  {checkListForms?.length !== 0 ? (
                                    <>
                                      {checkListForms?.map((form) => {
                                        const formName =
                                          form?.companyDocumentNamesId
                                            ?.documentName || form?.formName;
                                        let filled = false;
                                        let status = null;
                                        let updatedAt;
                                        let remarks = "";
                                        let isFilled = false;
                                        let accepted = "";
                                        let documentDetails = "";
                                        filledForms?.map((fill) => {
                                          if (
                                            form._id ===
                                            fill.companyDocumentId._id
                                          ) {
                                            filled = true;
                                            status = fill.formStatusByHR;
                                            updatedAt = fill.updatedAt;
                                            remarks = fill.remarks;
                                            isFilled = fill.isFilledStatus;
                                            accepted = fill.createdAt;
                                            documentDetails =
                                              fill.documentDetails;
                                          }
                                        });
                                        if (
                                          businessType ===
                                          form.businessType.toLowerCase()
                                        ) {
                                          return (
                                            <tr key={Math.random()}>
                                              <td
                                                className={`table-column-head ${
                                                  isFilled === false &&
                                                  status === null
                                                    ? "fw-normal"
                                                    : ""
                                                }`}
                                              >
                                                {formName}
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              </td>
                                              {!hideColumnReason() && (
                                                <td className="table-column-head">
                                                  {isFilled === false &&
                                                    status === false && (
                                                      <div
                                                        className="d-flex reject"
                                                        style={{ color: "red" }}
                                                      >
                                                        <div className="reject_icon">
                                                          <i className="fa fa-close"></i>
                                                        </div>
                                                        {remarks}
                                                      </div>
                                                    )}
                                                </td>
                                              )}
                                              <td className="table-column-head">
                                                {updatedAt
                                                  ? formatDateDDMMYYYY(
                                                      new Date(updatedAt),
                                                    )
                                                  : ""}
                                              </td>
                                              <td className="table-column-head">
                                                {isFilled === false &&
                                                status === null ? (
                                                  <Pending />
                                                ) : (
                                                  <>
                                                    {(status === null ||
                                                      status === false) &&
                                                    isFilled === true ? (
                                                      <ReadyForReview />
                                                    ) : (
                                                      <>
                                                        {status ? (
                                                          <Verified />
                                                        ) : (
                                                          <Rejected />
                                                        )}
                                                      </>
                                                    )}
                                                  </>
                                                )}
                                              </td>
                                              <td className="table-column-head justify-content-center d-flex">
                                                <button
                                                  style={{ flex: 1 }}
                                                  className={`btn-sm ${
                                                    !application?.candidateSignatureStatus
                                                      ? "btn-secondary"
                                                      : "btn-primary"
                                                  }`}
                                                  disabled={
                                                    !application?.candidateSignatureStatus
                                                  }
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    filled
                                                      ? status === null
                                                        ? getFilledFormPreviewData(
                                                            e,
                                                            form._id,
                                                            filled,
                                                            status,
                                                            accepted,
                                                            form.formData,
                                                            documentDetails,
                                                            form,
                                                          )
                                                        : getFilledFormPreviewData(
                                                            e,
                                                            form._id,
                                                            filled,
                                                            status,
                                                            accepted,
                                                            form.formData,
                                                            documentDetails,
                                                            form,
                                                          )
                                                      : getFormPreviewData(
                                                          e,
                                                          form._id,
                                                          filled,
                                                          status,
                                                          accepted,
                                                          form.formData,
                                                          documentDetails,
                                                          form,
                                                        );
                                                  }}
                                                >
                                                  {filled
                                                    ? status === null
                                                      ? "View Form"
                                                      : status
                                                        ? "View Form"
                                                        : "Re Fill Form"
                                                    : "Fill Form"}
                                                </button>
                                              </td>
                                            </tr>
                                          );
                                        }
                                      })}
                                    </>
                                  ) : (
                                    <tr>
                                      <td colSpan={3}>No Data Found</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          )}
                        </Card>
                      </>
                    )}

                  {offerLetterSended && (
                    <OfferLetter
                      tokenType={"candidate"}
                      filledForms={filledForms}
                      offerLetterSended={offerLetterSended}
                      application={application}
                      loadApplication={loadApplication}
                      getAllJoiningFilledForms={getAllJoiningFilledForms}
                    />
                  )}

                  {canShowDeclarationForm && (
                    <Card
                      className={`border mb-4 bg-white ${
                        !isDeclarationSubmitted ? "new" : ""
                      }`}
                      title="Declaration Form"
                    >
                      <div style={{ width: "100%" }}>
                        <Table
                          columns={declarationColumns}
                          dataSource={declarationRows}
                          pagination={false}
                          scroll={{ x: true }}
                          style={{ whiteSpace: "pre" }}
                          size="small"
                        />
                      </div>
                    </Card>
                  )}

                  {canShowConsentForm && (
                    <Card
                      className={`border mb-4 bg-white ${
                        !isConsentAccepted ? "new" : ""
                      }`}
                      title="Consent Form"
                    >
                      <div style={{ width: "100%" }}>
                        <Table
                          columns={consentColumns}
                          dataSource={consentRows}
                          pagination={false}
                          scroll={{ x: true }}
                          style={{ whiteSpace: "pre" }}
                          size="small"
                        />
                      </div>
                    </Card>
                  )}

                  {canShowLegalDocs ? (
                    <>
                      <Card className={"mb-4"} title="Legal Documents">
                        <Collapse
                          style={{ position: "relative" }}
                          onChange={(key) => {
                            if (
                              !application?.offerLetterAccepted
                            ) {
                              setOfferLetterPopup(true);
                              return;
                            }
                            if (shouldBlockDocumentationForDeclaration) {
                              setDeclarationFormPopup(true);
                              return;
                            }
                            handleAlert(key);
                          }}
                          accordion
                          activeKey={activePanel}
                        >
                          {application?.accidental?.toLowerCase() === "yes" &&
                            LegalDocument({
                              keyName: "Accidental_Form",
                              formTitle: "Accidental Form",
                              formComponent: Accidental,
                              filledFormData: AccidentalFormData,
                              previewSetter: { setAccidentalPreviewData },
                              ...legalDocsCommonProps,
                            })}
                          {/* Mediclaim */}
                          {application?.mediclaim?.toLowerCase() === "yes" &&
                            LegalDocument({
                              keyName: "Mediclaim_Form",
                              formTitle: "Mediclaim Form",
                              formComponent: Mediclaim,
                              filledFormData: MediclaimFormData,
                              previewSetter: { setMediclaimPreviewData },
                              ...legalDocsCommonProps,
                            })}
                          {/* EPF */}
                          {application?.EPFO?.toLowerCase() === "yes" &&
                            LegalDocument({
                              keyName: "EPF_Form",
                              formTitle: "EPF Form",
                              formComponent: EPF,
                              filledFormData: EPFFormData,
                              previewSetter: { setEPFPreviewData },
                              additionalProps: {
                                nomineeGratuity: GratuityFormData,
                                nomineeWages: WagesFormData,
                              },
                              ...legalDocsCommonProps,
                            })}
                          {/* Gratuity */}
                          {application?.gratuity?.toLowerCase() === "yes" &&
                            LegalDocument({
                              keyName: "Gratuity_Form",
                              formTitle: "Gratuity Form",
                              formComponent: Gratuity,
                              filledFormData: GratuityFormData,
                              previewSetter: { setGratuityPreviewData },
                              additionalProps: {
                                nomineeEPF: EPFFormData,
                                nomineeGratuity: GratuityFormData,
                              },
                              ...legalDocsCommonProps,
                            })}
                          {/* Wages FORM */}
                          {LegalDocument({
                            keyName: "Wages_Form",
                            formTitle: "Wages Form",
                            formComponent: Wages,
                            filledFormData: WagesFormData,
                            previewSetter: { setWagesPreviewData },
                            additionalProps: {
                              nomineeEPF: EPFFormData,
                              nomineeGratuity: GratuityFormData,
                            },
                            ...legalDocsCommonProps,
                          })}
                          {/* ESI */}
                          {application?.ESI?.toLowerCase() === "yes" &&
                            LegalDocument({
                              keyName: "ESI_Form",
                              formTitle: "ESI Form",
                              formComponent: ESIForm,
                              filledFormData: ESIFormData,
                              previewSetter: { setESIPreviewData },
                              ...legalDocsCommonProps,
                            })}
                          {/* Form 11 */}
                          {LegalDocument({
                            keyName: "Form_11",
                            formTitle: "Form 11",
                            formComponent: Form11,
                            filledFormData: Form11FormData,
                            previewSetter: { setForm11PreviewData },
                            additionalProps: {
                              uanDetails,
                            },
                            ...legalDocsCommonProps,
                          })}
                        </Collapse>
                      </Card>
                      <Card className={" bg-white mb-4"} title="Joining Forms">
                        <div style={{ width: "100%" }}>
                          <Table
                            columns={joiningColumns}
                            dataSource={joiningRows}
                            pagination={false}
                            scroll={{ x: true }}
                            style={{ whiteSpace: "pre" }}
                            size="small"
                          />
                        </div>
                      </Card>
                    </>
                  ) : (
                    ""
                  )}
                  <div className="row">
                    <div className="col-md-6">
                      <Photo
                        application={application}
                        loadApplication={loadApplication}
                        url={files?.photo}
                        uploadedFile={application?.candidatePhoto}
                        aiSettings={aiSettings}
                      />
                    </div>
                    <div className="col-md-6">
                      <Signature
                        application={application}
                        loadApplication={loadApplication}
                        url={files?.sign}
                        aiSettings={aiSettings}
                        uploadedFile={application?.candidateSignature}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <AadharCard
                        application={application}
                        uploadedFile={application?.aadharCardImage}
                        getAadharAndPanDetails={getAadharAndPanDetails}
                        loadApplication={loadApplication}
                        url={files?.aadhar}
                        aadharDetails={aadharDetails}
                        aiSettings={aiSettings}
                        setDisabledDueToAadhar={setDisabledDueToAadhar}
                      />
                    </div>
                    <div className="col-md-6">
                      <Badge.Ribbon
                        text="Please Complete Aadhar First"
                        color="red"
                        style={{
                          display: disabledDueToAadhar ? "block" : "none",
                        }}
                      >
                        <PanCard
                          application={application}
                          uploadedFile={application?.panCardImage}
                          getAadharAndPanDetails={getAadharAndPanDetails}
                          loadApplication={loadApplication}
                          url={files?.pan}
                          aiSettings={aiSettings}
                          panDetails={panDetails}
                          disabledDueToAadhar={disabledDueToAadhar}
                        />
                      </Badge.Ribbon>
                    </div>
                  </div>
                  <Badge.Ribbon
                    text="Please Complete Aadhar First"
                    color="red"
                    style={{
                      display: disabledDueToAadhar ? "block" : "none",
                    }}
                  >
                    <DocumentForms
                      id={id}
                      activeDocKey={activeDocKey}
                      isInputFieldTouched={isInputFieldTouched}
                      disabledDueToAadhar={disabledDueToAadhar}
                      aiSettings={aiSettings}
                      handleAlert={handleAlert}
                      application={application}
                      pageRefresh={pageRefresh}
                      toggleAlert={toggleAlert}
                      setActiveDocKey={setActiveDocKey}
                      setIsFieldTouch={setIsFieldTouch}
                      onBlurHandler={onBlurHandler}
                      aadharDetails={aadharDetails}
                      isFieldTouch={isFieldTouch}
                      setToggleAlert={setToggleAlert}
                    />
                  </Badge.Ribbon>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <Modal
        centered
        open={open}
        onOk={() => setOpen(false)}
        onCancel={(e) => {
          setAccept(false);
          setOpen(false);
        }}
        width={1000}
        footer={
          showHideFooter &&
          !formLoading && (
            <div className="mt-2 d-flex gap-1 align-items-center flex-column justify-content-center">
              <div
                className="d-flex"
                style={{
                  gap: "0.5rem",
                  alignItems: "start",
                  width: "100%",
                  paddingLeft: "25px",
                }}
              >
                <input
                  id="accept"
                  type="checkbox"
                  style={{ marginTop: "5px" }}
                  value={accept}
                  checked={accept}
                  onChange={(e) => setAccept(!accept)}
                />
                <label
                  className="mb-0"
                  style={{ textAlign: "left" }}
                  htmlFor="accept"
                >
                  <strong>
                    By accepting these terms and conditions, you confirm that
                    you have read and agree to abide by the terms outlined
                    above, digitally signing the agreement.
                  </strong>
                </label>
              </div>
              <button
                disabled={!accept}
                className={`btn ${
                  accept ? "btn-primary" : "btn-secondary"
                } mt-2`}
                onClick={(e) => acceptFormHandler(e)}
              >
                Submit
              </button>
              {checklistError && (
                <div
                  className="d-flex"
                  style={{
                    alignItems: "start",
                    width: "100%",
                    paddingLeft: "25px",
                    marginBottom: "1rem",
                    justifyContent: "center",
                  }}
                >
                  <label
                    className="mb-0"
                    style={{ textAlign: "left", color: "red" }}
                  >
                    <strong>{checklistError}</strong>
                  </label>
                </div>
              )}
            </div>
          )
        }
      >
        <LoadingArea isLoading={formLoading}>
          <div id="joining_preview"></div>
        </LoadingArea>
      </Modal>

      <Modal
        centered
        open={leaglFormOpen}
        onOk={() => setLeaglFormOpen(false)}
        onCancel={(e) => {
          setLeaglFormOpen(false);
        }}
        width={1000}
        footer={<></>}
      >
        <div className="d-flex" style={{ justifyContent: "center" }}>
          <div id="legal_preview" style={{ width: "710px" }}></div>
        </div>
      </Modal>

      <Modal
        title="Consent Form"
        centered
        open={consentFormModal}
        onOk={() => setConsentFormModal(false)}
        onCancel={(e) => {
          setConsentFormModal(false);
        }}
        width={1000}
        footer={null}
      >
        {/* <ConsentForm s3Files={s3Files} candidate={application} /> */}
        <LoadingArea isLoading={load}>
          <div className="w-100">
            <iframe
              style={{ width: "100%" }}
              title="iframe"
              className="iframe"
              width="100%"
              height="600"
              src={concentUrl}
              allow="fullscreen; autoplay; clipboard-read; clipboard-write"
            >
              <p>iframes are not supported by your browser.</p>
            </iframe>
            {!application?.concentStatus && !formLoading && (
              <div className="mt-2 d-flex gap-1 align-items-center flex-column justify-content-center">
                <div
                  className="d-flex"
                  style={{
                    gap: "0.5rem",
                    width: "100%",
                    alignItems: "start",
                    paddingLeft: "25px",
                  }}
                >
                  <input
                    id="accept"
                    type="checkbox"
                    style={{ marginTop: "5px" }}
                    value={accept}
                    checked={accept}
                    onChange={(e) => setAccept(!accept)}
                  />
                  <label
                    style={{ textAlign: "left" }}
                    className="mb-0"
                    htmlFor="accept"
                  >
                    <strong>
                      By accepting these terms and conditions, you confirm that
                      you have read and agree to abide by the terms outlined
                      above, digitally signing the agreement.
                    </strong>
                  </label>
                </div>
                <button
                  disabled={!accept}
                  className={`btn ${
                    accept ? "btn-primary" : "btn-secondary"
                  } mt-2`}
                  onClick={(e) => acceptConsentFormHandler(e)}
                >
                  Submit
                </button>
              </div>
            )}
          </div>
        </LoadingArea>
      </Modal>

      <Modal
        title="Declaration Form"
        centered
        open={declarationFormModal}
        onOk={() => setDeclarationFormModal(false)}
        onCancel={() => {
          setDeclarationFormModal(false);
          setDeclarationAccept(false);
        }}
        width={1000}
        footer={null}
      >
        <LoadingArea isLoading={load}>
          <div className="w-100">
            <iframe
              style={{ width: "100%" }}
              title="declaration-iframe"
              className="iframe"
              width="100%"
              height="600"
              src={declarationUrl}
              allow="fullscreen; autoplay; clipboard-read; clipboard-write"
            >
              <p>iframes are not supported by your browser.</p>
            </iframe>
            {canSubmitDeclaration && !formLoading && (
              <div className="mt-2 d-flex gap-1 align-items-center flex-column justify-content-center">
                <div
                  className="d-flex"
                  style={{
                    gap: "0.5rem",
                    width: "100%",
                    alignItems: "start",
                    paddingLeft: "25px",
                  }}
                >
                  <input
                    id="declaration_accept"
                    type="checkbox"
                    style={{ marginTop: "5px" }}
                    value={declarationAccept}
                    checked={declarationAccept}
                    onChange={() =>
                      setDeclarationAccept(!declarationAccept)
                    }
                  />
                  <label
                    style={{ textAlign: "left" }}
                    className="mb-0"
                    htmlFor="declaration_accept"
                  >
                    <strong>
                      I confirm that I have read and agree to submit this
                      declaration using my digital signature.
                    </strong>
                  </label>
                </div>
                <button
                  disabled={!declarationAccept}
                  className={`btn ${
                    declarationAccept ? "btn-primary" : "btn-secondary"
                  } mt-2`}
                  onClick={(e) => acceptDeclarationFormHandler(e)}
                >
                  Give Consent
                </button>
              </div>
            )}
          </div>
        </LoadingArea>
      </Modal>

      <Modal
        title="Reject"
        centered
        open={reject}
        onOk={() => setReject(false)}
        onCancel={() => setReject(false)}
        width={1000}
        footer={
          <div className="d-flex gap-1 align-items-center justify-content-center">
            <button className="btn btn-primary" onClick={() => setReject(true)}>
              Submit
            </button>
          </div>
        }
      >
        <div className="row">
          <div className="form-group col-md-12 form-builder-element mb-3">
            <label for="">Comment</label>
            <textarea
              className="form-control"
              placeholder="Enter Input here..."
            ></textarea>
          </div>
        </div>
      </Modal>

      <Modal
        title=""
        className="p-0 custom_modal__"
        style={{ height: "70dvh", top: "-3%" }}
        centered
        open={openUnderstandModal}
        width={800}
        closable={false}
        footer={
          <div className="d-flex gap-1 align-items-center justify-content-center">
            <button
              className="btn btn-primary"
              onClick={() => setOpenUnderstandModal(false)}
            >
              I Read & Understand
            </button>
          </div>
        }
      >
        <Guidelines />
      </Modal>

      {offerLetterPopup && (
        <OfferLetterPopup
          show={offerLetterPopup}
          setShow={setOfferLetterPopup}
        />
      )}
      {declarationFormPopup && (
        <OfferLetterPopup
          show={declarationFormPopup}
          setShow={setDeclarationFormPopup}
          title="Declaration Form Acceptance"
          message="Please accept your declaration form to proceed further with documentation."
        />
      )}
    </CandidateDashboard>
  );
};

export default ViewApplication;
